document.addEventListener('DOMContentLoaded', () => {
  let resizeHandler;
  let scrollHandler;
  let variantChangeHandler;
  let loadHandler;
  let upButtonHandler;
  let downButtonHandler;
  let isInitialized = false;

  let isDesktop = () => window.innerWidth >= 1000;

  let initDesktopGallery = () => {
    if (isInitialized) return;
    
    let galleryContainer = document.querySelector('.product-gallery__two-column');
    if (!galleryContainer) return;

    let secondaryImages = document.querySelector('.product-gallery__secondary-images');
    let mediaItems = secondaryImages?.querySelectorAll('.product-gallery__media');
    let firstImageContainer = document.querySelector('.product-gallery__first-image');

    if (!secondaryImages || !mediaItems || mediaItems.length === 0 || !firstImageContainer) return;

    let isButtonScrolling = false;

    let createHiddenCarousel = () => {
      let productGallery = document.querySelector('product-gallery');
      if (!productGallery) return;

      if (productGallery.querySelector('.product-gallery__carousel')) return;

      let hiddenCarousel = document.createElement('scroll-carousel');
      hiddenCarousel.id = productGallery.id + '-carousel';
      hiddenCarousel.className = 'product-gallery__carousel';
      hiddenCarousel.setAttribute('role', 'region');
      hiddenCarousel.style.display = 'none';
      hiddenCarousel.style.position = 'absolute';
      hiddenCarousel.style.visibility = 'hidden';

      let firstMediaClone = createMediaElement(
        firstImageContainer.querySelector('img, video, model-viewer'),
        0
      );
      hiddenCarousel.appendChild(firstMediaClone);

      let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
        !item.hasAttribute('hidden') && !item.classList.contains('static-image')
      );

      visibleSecondaryItems.forEach((mediaItem, index) => {
        let mediaElement = mediaItem.querySelector('img, video, model-viewer');
        if (mediaElement) {
          let mediaClone = createMediaElement(mediaElement, index + 1);
          hiddenCarousel.appendChild(mediaClone);
        }
      });

      productGallery.appendChild(hiddenCarousel);

      updateZoomButtonIndices();
    };

    let createMediaElement = (sourceElement, index) => {
      if (!sourceElement) return null;

      let mediaDiv = document.createElement('div');
      mediaDiv.className = 'product-gallery__media snap-center';
      mediaDiv.setAttribute('data-media-type', sourceElement.tagName.toLowerCase() === 'img' ? 'image' : 'video');
      mediaDiv.setAttribute('role', 'group');

      let clonedElement = sourceElement.cloneNode(true);
      mediaDiv.appendChild(clonedElement);

      return mediaDiv;
    };

    let updateZoomButtonIndices = () => {
      let staticImageZoomButton = firstImageContainer.querySelector('open-lightbox-button');
      if (staticImageZoomButton) {
        staticImageZoomButton.setAttribute('image-index', '0');
      }

      let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
        !item.hasAttribute('hidden') && !item.classList.contains('static-image')
      );

      visibleSecondaryItems.forEach((mediaItem, index) => {
        let zoomButton = mediaItem.querySelector('open-lightbox-button');
        if (zoomButton) {
          zoomButton.setAttribute('image-index', (index + 1).toString());
        }
      });
    };

    let updateHiddenCarousel = () => {
      let productGallery = document.querySelector('product-gallery');
      let hiddenCarousel = productGallery?.querySelector('.product-gallery__carousel');

      if (!hiddenCarousel) {
        createHiddenCarousel();
        return;
      }

      hiddenCarousel.innerHTML = '';

      let firstMediaClone = createMediaElement(
        firstImageContainer.querySelector('img, video, model-viewer'),
        0
      );
      hiddenCarousel.appendChild(firstMediaClone);

      let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
        !item.hasAttribute('hidden') && !item.classList.contains('static-image')
      );

      visibleSecondaryItems.forEach((mediaItem, index) => {
        let mediaElement = mediaItem.querySelector('img, video, model-viewer');
        if (mediaElement) {
          let mediaClone = createMediaElement(mediaElement, index + 1);
          hiddenCarousel.appendChild(mediaClone);
        }
      });

      let scrollTop = secondaryImages.scrollTop;
      let currentVisibleIndex = 0;

      for (let i = 0; i < visibleSecondaryItems.length; i++) {
        if (visibleSecondaryItems[i].offsetTop > scrollTop + 10) {
          break;
        }
        currentVisibleIndex = i;
      }

      let selectedIndex = currentVisibleIndex + 1;

      if (selectedIndex < hiddenCarousel.cells.length) {
        hiddenCarousel.select(selectedIndex, { instant: true });
      } else {
        hiddenCarousel.select(0, { instant: true });
      }

      updateZoomButtonIndices();
    };

    let updateHiddenCarouselSelectedIndex = (mediaItem) => {
      let productGallery = document.querySelector('product-gallery');
      let hiddenCarousel = productGallery?.querySelector('.product-gallery__carousel');

      if (!hiddenCarousel || !hiddenCarousel.cells) return;

      let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
        !item.hasAttribute('hidden') && !item.classList.contains('static-image')
      );
      let mediaItemIndex = visibleSecondaryItems.indexOf(mediaItem);

      if (mediaItemIndex !== -1) {
        let selectedIndex = mediaItemIndex + 1;

        if (selectedIndex < hiddenCarousel.cells.length) {
          hiddenCarousel.select(selectedIndex, { instant: true });
        } else {
          hiddenCarousel.select(0, { instant: true });
        }

        if (counterCurrent && counterTotal && !isProcessingVariantChange) {
          counterCurrent.textContent = mediaItemIndex + 1;
          counterTotal.textContent = visibleSecondaryItems.length;
        }
      }
    };

    createHiddenCarousel();

    let currentColor = '';

    let setExactHeight = () => {
      let firstVisibleMedia = Array.from(mediaItems).find(item => !item.hasAttribute('hidden'));
      if (!firstVisibleMedia) return;
      let mediaHeight = firstVisibleMedia.offsetHeight;
      let secondaryContainer = document.querySelector('.product-gallery__secondary-images-container');

      if (secondaryContainer) {
        secondaryContainer.style.height = `${mediaHeight}px`;
      }


      let firstImage = document.querySelector('.product-gallery__first-image');
      if (firstImage) {
        firstImage.style.height = `${mediaHeight}px`;
      }

      mediaItems.forEach(item => {
        if (!item.hasAttribute('hidden')) {
          item.style.display = 'block';
          item.style.scrollSnapAlign = 'start';
          item.style.scrollSnapStop = 'always';
        }
      });

      secondaryContainer.style.scrollSnapType = 'y mandatory';
    };


    setExactHeight();

    resizeHandler = setExactHeight;
    window.addEventListener('resize', resizeHandler);

    loadHandler = setExactHeight;
    window.addEventListener('load', loadHandler);

    secondaryImages.style.scrollBehavior = 'smooth';

    let isScrolling;
    let lastScrollTop = 0;

    scrollHandler = () => {
      window.clearTimeout(isScrolling);

      isScrolling = setTimeout(() => {
        let scrollTop = secondaryImages.scrollTop;

        let closestItem = null;
        let closestDistance = Infinity;

        mediaItems.forEach(item => {
          if (item.hasAttribute('hidden') || item.classList.contains('static-image')) return;

          let itemTop = item.offsetTop;
          let distance = Math.abs(scrollTop - itemTop);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = item;
          }
        });

        if (closestItem) {
          secondaryImages.scrollTo({
            top: closestItem.offsetTop,
            behavior: 'smooth'
          });
        }

        lastScrollTop = scrollTop;
      }, 100);
    };

    secondaryImages.addEventListener('scroll', scrollHandler);

    let upButton = document.querySelector('.product-gallery__nav-up');
    let downButton = document.querySelector('.product-gallery__nav-down');

    if (upButton && downButton) {
      let findPreviousVisibleItem = (currentTop) => {
        let previousItem = null;

        for (let i = mediaItems.length - 1; i >= 0; i--) {
          let item = mediaItems[i];
          if (item.hasAttribute('hidden') || item.classList.contains('static-image')) continue;

          if (item.offsetTop < currentTop && (previousItem === null || item.offsetTop > previousItem.offsetTop)) {
            previousItem = item;
          }
        }

        return previousItem;
      };

      let findNextVisibleItem = (currentTop) => {
        let nextItem = null;

        for (let i = 0; i < mediaItems.length; i++) {
          let item = mediaItems[i];
          if (item.hasAttribute('hidden') || item.classList.contains('static-image')) continue;

          if (item.offsetTop > currentTop && (nextItem === null || item.offsetTop < nextItem.offsetTop)) {
            nextItem = item;
          }
        }

        return nextItem;
      };

      upButtonHandler = () => {
        let currentScrollTop = secondaryImages.scrollTop;
        let previousItem = findPreviousVisibleItem(currentScrollTop);
        isButtonScrolling = true;

        if (previousItem) {
          let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
              !item.hasAttribute('hidden') && !item.classList.contains('static-image')
          );

          let itemIndex = visibleSecondaryItems.indexOf(previousItem);

          if (counterCurrent && counterTotal) {
            counterCurrent.textContent = itemIndex + 1;
            counterTotal.textContent = visibleSecondaryItems.length;
          }

          secondaryImages.scrollTo({
            top: previousItem.offsetTop,
            behavior: 'smooth'
          });
          updateHiddenCarouselSelectedIndex(previousItem);
          updateZoomButtonIndices();
        } else {
          if (counterCurrent) {
            counterCurrent.textContent = '1';
          }

          secondaryImages.scrollTo({
            top: 0,
            behavior: 'smooth'
          });

          let firstVisibleItem = Array.from(mediaItems).find(item =>
              !item.hasAttribute('hidden') && !item.classList.contains('static-image')
          );
          if (firstVisibleItem) {
            updateHiddenCarouselSelectedIndex(firstVisibleItem);
            updateZoomButtonIndices();
          }
        }

        setTimeout(() => {
          isButtonScrolling = false;
        }, 500);
      };

      downButtonHandler = () => {
        let currentScrollTop = secondaryImages.scrollTop;
        let nextItem = findNextVisibleItem(currentScrollTop + 1);

        isButtonScrolling = true;

        if (nextItem) {
          let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
              !item.hasAttribute('hidden') && !item.classList.contains('static-image')
          );

          let itemIndex = visibleSecondaryItems.indexOf(nextItem);

          if (counterCurrent && counterTotal) {
            counterCurrent.textContent = itemIndex + 1;
            counterTotal.textContent = visibleSecondaryItems.length;
          }

          secondaryImages.scrollTo({
            top: nextItem.offsetTop,
            behavior: 'smooth'
          });

          updateHiddenCarouselSelectedIndex(nextItem);
          updateZoomButtonIndices();
        } else {
          let visibleItems = Array.from(mediaItems).filter(item =>
              !item.hasAttribute('hidden') && !item.classList.contains('static-image')
          );
          if (visibleItems.length > 0) {
            let lastItem = visibleItems[visibleItems.length - 1];

            if (counterCurrent && counterTotal) {
              counterCurrent.textContent = visibleItems.length;
              counterTotal.textContent = visibleItems.length;
            }

            secondaryImages.scrollTo({
              top: lastItem.offsetTop,
              behavior: 'smooth'
            });

            updateHiddenCarouselSelectedIndex(lastItem);
            updateZoomButtonIndices();
          }
        }

        setTimeout(() => {
          isButtonScrolling = false;
        }, 500);
      };

      upButton.removeEventListener('click', upButtonHandler);
      downButton.removeEventListener('click', downButtonHandler);

      upButton.addEventListener('click', upButtonHandler);
      downButton.addEventListener('click', downButtonHandler);
    }

    let updateFirstImage = (colorChanged = false) => {
      let firstImageContainer = document.querySelector('.product-gallery__first-image');
      if (!firstImageContainer) return;

      // Remove static-image class from all items
      mediaItems.forEach(item => {
        if (item.classList.contains('static-image')) {
          item.classList.remove('static-image');
        }
      });

      // We don't need to find the first visible media anymore
      // We want to keep the original first image in the left column

      // Check if we need to add a zoom button to the first image container
      let isInitialLoad = !document.querySelector('.product-gallery__first-image img, .product-gallery__first-image video, .product-gallery__first-image model-viewer');
      if (isInitialLoad) {
        // Only add zoom button if needed, don't replace the content
        let zoomButton = document.createElement('open-lightbox-button');
        zoomButton.setAttribute('aria-controls', document.querySelector('product-gallery')?.id);
        zoomButton.setAttribute('image-index', '0');
        zoomButton.className = 'block sm-max:hidden';
        
        let button = document.createElement('button');
        button.className = 'product-zoom-button';
        zoomButton.appendChild(button);
        
        firstImageContainer.appendChild(zoomButton);
      }

      // Hide the duplicate of the first image in the secondary images
      let firstMediaId = firstImageContainer.querySelector('img, video, model-viewer')?.getAttribute('data-media-id');
      
      if (firstMediaId) {
        mediaItems.forEach(item => {
          if (item.getAttribute('data-media-id') === firstMediaId) {
            item.setAttribute('hidden', 'true');
          }
        });
      }
    };

    let isProcessingVariantChange = false;

    variantChangeHandler = (e) => {
      let variant = e.detail.variant;
      let newColor = variant.option1?.toLowerCase();

      let colorChanged = newColor !== currentColor;
      currentColor = newColor;

      isProcessingVariantChange = true;

      let currentCounterValue = counterCurrent ? counterCurrent.textContent : '1';
      let totalCounterValue = counterTotal ? counterTotal.textContent : '1';

      if (counterCurrent && counterTotal) {
        if (!colorChanged) {
          counterCurrent.textContent = currentCounterValue;
          counterTotal.textContent = totalCounterValue;
        } else {
          counterCurrent.textContent = '1';
        }
      }

      setTimeout(() => {
        updateFirstImage(colorChanged);
        setExactHeight();

        if (colorChanged) {
          secondaryImages.scrollTo({
            top: 0,
            behavior: 'instant'
          });
        }

        updateHiddenCarousel();

        setTimeout(() => {
          let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
            !item.hasAttribute('hidden') && !item.classList.contains('static-image')
          );

          if (counterCurrent && counterTotal) {
            if (colorChanged) {
              counterCurrent.textContent = '1';
            }
            counterTotal.textContent = visibleSecondaryItems.length;
          }

          isProcessingVariantChange = false;
        }, 150);
      }, 100);
    };

    document.addEventListener('variant:change', variantChangeHandler);

    let counterCurrent = document.querySelector('.product-gallery__counter .current-image');
    let counterTotal = document.querySelector('.product-gallery__counter .total-images');

    updateFirstImage(true); // Pass true for initial load to ensure first image is set correctly

    let updateCounter = () => {
      if (isProcessingVariantChange || !counterCurrent || !counterTotal) return;

      let visibleItems = Array.from(mediaItems).filter(item =>
          !item.hasAttribute('hidden') && !item.classList.contains('static-image')
      );

      if (visibleItems.length === 0) return;

      let totalImages = visibleItems.length;

      let scrollTop = secondaryImages.scrollTop;
      let currentIndex = 0;

      for (let i = 0; i < visibleItems.length; i++) {
        if (visibleItems[i].offsetTop > scrollTop + 10) {
          break;
        }
        currentIndex = i;
      }

      counterCurrent.textContent = currentIndex + 1;
      counterTotal.textContent = totalImages;
    };

    secondaryImages.addEventListener('scroll', () => {
      if (isProcessingVariantChange) return;

      let visibleSecondaryItems = Array.from(mediaItems).filter(item =>
        !item.hasAttribute('hidden') && !item.classList.contains('static-image')
      );

      if (visibleSecondaryItems.length === 0) return;

      let scrollTop = secondaryImages.scrollTop;
      let currentVisibleIndex = 0;

      for (let i = 0; i < visibleSecondaryItems.length; i++) {
        if (visibleSecondaryItems[i].offsetTop > scrollTop + 10) {
          break;
        }
        currentVisibleIndex = i;
      }

      if (!isButtonScrolling) {
        if (counterCurrent && counterTotal) {
          counterCurrent.textContent = currentVisibleIndex + 1;
          counterTotal.textContent = visibleSecondaryItems.length;
        }
      }

      let productGallery = document.querySelector('product-gallery');
      let hiddenCarousel = productGallery?.querySelector('.product-gallery__carousel');

      if (hiddenCarousel && hiddenCarousel.cells) {
        let selectedIndex = currentVisibleIndex + 1;

        if (selectedIndex < hiddenCarousel.cells.length) {
          hiddenCarousel.select(selectedIndex, { instant: true });
        } else {
          hiddenCarousel.select(0, { instant: true });
        }

        updateZoomButtonIndices();
      }
    });

    updateCounter();
    
    isInitialized = true;
  };

  let destroyDesktopGallery = () => {
    if (!isInitialized) return;

    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('load', loadHandler);
    
    let secondaryImages = document.querySelector('.product-gallery__secondary-images');
    if (secondaryImages) {
      secondaryImages.removeEventListener('scroll', scrollHandler);
      secondaryImages.style.height = '';
      secondaryImages.style.scrollSnapType = '';
      secondaryImages.style.scrollBehavior = '';

      let mediaItems = secondaryImages.querySelectorAll('.product-gallery__media');
      mediaItems.forEach(item => {
        if (item.classList.contains('static-image')) {
          item.classList.remove('static-image');
          item.removeAttribute('hidden');
        }
        item.style.scrollSnapAlign = '';
        item.style.scrollSnapStop = '';
        item.style.display = '';
      });
    }
    
    document.removeEventListener('variant:change', variantChangeHandler);

    let upButton = document.querySelector('.product-gallery__nav-up');
    let downButton = document.querySelector('.product-gallery__nav-down');
    
    if (upButton && upButtonHandler) {
      upButton.removeEventListener('click', upButtonHandler);
    }
    
    if (downButton && downButtonHandler) {
      downButton.removeEventListener('click', downButtonHandler);
    }
    
    isInitialized = false;
  };

  if (isDesktop()) {
    initDesktopGallery();
  }

  window.addEventListener('resize', () => {
    if (isDesktop() && !isInitialized) {
      initDesktopGallery();
    } else if (!isDesktop() && isInitialized) {
      destroyDesktopGallery();
    }
  });
});